function _slicedToArray(arr, i) {return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();}function _nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr, i) {var _arr = [];var _n = true;var _d = false;var _e = undefined;try {for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}function _arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import { getCurrentDay } from "../../shared/helpers/date-time";
import { browserLocale } from "../../shared/helpers/browser-locale";

var _private = {
  user: null,
  promise: null };


var localStorageKey = 'authenticatedAccount';


export var UserService = /*#__PURE__*/function () {UserService.$inject = ["$rootScope", "$q", "$localStorage", "$http", "$window", "gplansConf", "ApiHttp", "CurrentUserModel", "MiscModel"];
  function UserService(
  $rootScope,
  $q,
  $localStorage,
  $http,
  $window,
  gplansConf,
  ApiHttp,
  // Profile,
  CurrentUserModel,
  MiscModel)
  {
    "ngInject";_classCallCheck(this, UserService);
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$window = $window;
    this.$localStorage = $localStorage;
    this.gplansConf = gplansConf;
    this.ApiHttp = ApiHttp;
    // this.Profile = Profile;
    this.CurrentUserModel = CurrentUserModel;
    this.MiscModel = MiscModel;

    _private.user = new CurrentUserModel(
    this.$localStorage[localStorageKey]);


    this._myMealPlan = undefined;
    this._mSystem = undefined;
    this._myMealPlanAtWeekNumber = undefined;
    this._weekNumber = undefined;
    this.measurementSystem = null;
    this.hasTwoWeeksAccelerator = false;
    this.isRecipesDisabled = false;
    this._weekNavigator = {};
  }_createClass(UserService, [{ key: "create", value: function create(














    oAccount, nextState, nextParams) {var _this = this;
      return this.$http.post(this.ApiHttp.authCreateAccount, oAccount).
      then(function (data, status, headers, config) {
        var result = data.data;
        _this.setToLocalStorage(result);
        return result;
      }).
      catch(function (err) {
        console.error(err);
        return _this.$q.reject(err);
      });
    } }, { key: "set", value: function set(

    data) {
      if (!data) {
        console.warn("trying to set ".concat(data, " to CurrentUserService"));
        return; // error will be thrower
      }
      return _private.user.$update(data);
    } }, { key: "reset", value: function reset()

    {
      this._myMealPlan = undefined;
      this._mSystem = undefined;
      this._myMealPlanAtWeekNumber = undefined;
      this._weekNumber = undefined;
      this._weekNavigator = {};
      _private.user = new this.CurrentUserModel();
    } }, { key: "getSha256", value: function getSha256(

    value) {
      return this.$window.sha256(value);
    } }, { key: "setToLocalStorage", value: function setToLocalStorage(

    data) {
      this.set(data);
      _private.user.hashed_email = this.getSha256(_private.user.email);
      this.$localStorage[localStorageKey] = _private.user;
    } }, { key: "updateFromLocalStorage", value: function updateFromLocalStorage()

    {
      var userFromStorage = this.$localStorage[localStorageKey];
      if (userFromStorage.id) {
        this.set(userFromStorage);
      }
    } }, { key: "getCurrentUser", value: function getCurrentUser()

    {var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isLoaded = _private.user.id;
      var defer = this.$q.defer();
      if (isLoaded && !reload) {

        this.updateFromLocalStorage();
        defer.resolve(_private.user);

      } else {

        this.fetch().
        then(defer.resolve).
        catch(defer.reject);
      }

      return defer.promise;
    } }, { key: "fetch", value: function fetch()

    {var _this2 = this;
      if (_private.promise) return _private.promise;
      _private.promise = this.$q.all([
      this.CurrentUserModel.query(),
      this.MiscModel.get('twoWeeksAccelerator').then(function (res) {return res.value;}).catch(function (err) {return false;}),
      this.MiscModel.get('measurementSystem').then(function (res) {return res.value;}).catch(function (err) {
        return browserLocale() == 'en-us' ? 'US' : 'SI';
      }),
      this.MiscModel.get('disableRecipes').then(function (res) {return res.value;}).catch(function (err) {return false;}),
      this.$http.get(this.ApiHttp.weekNavigator).then(function (res) {return res.data;}).catch(function (err) {return false;})]).

      then(function (_ref) {var _ref2 = _slicedToArray(_ref, 5),responseUser = _ref2[0],twoWeeksAccelerator = _ref2[1],measurementSystem = _ref2[2],disableRecipes = _ref2[3],weekNavigator = _ref2[4];
        _this2.measurementSystem = measurementSystem;
        _this2.hasTwoWeeksAccelerator = twoWeeksAccelerator;
        _this2.isRecipesDisabled = parseInt(disableRecipes) === 1;
        if (responseUser.id) {
          _this2.setToLocalStorage(responseUser);
        }
        _this2.weekNavigator = weekNavigator;
        return _private.user;
      }).
      catch(function (err) {
        console.warn('User fetch failed:', err.statusText || err.message, err);
        throw err;
      }).
      finally(function () {
        _private.promise = null;
      });
      return _private.promise;
    } }, { key: "data", get: function get() {return _private.user;} }, { key: "disableRecipes", get: function get() {return this.isRecipesDisabled;} }, { key: "currentDayIndex", get: function get() {if (!this.data || !this.data.last_checkin || !this.data.last_checkin.created_at) return 0;return getCurrentDay(this.data.last_checkin.created_at) - 1;} }, { key: "weekNumber", get: function get()

    {
      var userWeekNumber = this.data && this.data.last_checkin && this.data.last_checkin.week_number || 0;
      if (!this.hasTwoWeeksAccelerator) userWeekNumber -= 2;
      if (userWeekNumber < 0) userWeekNumber = 0;
      return userWeekNumber;
    } }]);return UserService;}();